var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"","id":"footer-container"}},[_c('b-row',{staticClass:"h-100",attrs:{"align-v":"center","align-h":"center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }